module.exports = __webpack_public_path__ + "img/photo.5c314383.png";